<template>
  <v-footer class="site-footer py-6">
    <v-container>
      <v-row align="center">
        <v-col cols="12" md="6" class="text-center text-md-left">
          <span class="text-medium-emphasis">
            © {{ currentYear }} Shelf. Made with ❤️ for home cooks.
          </span>
        </v-col>
        <v-col cols="12" md="6" class="text-center text-md-right">
          <v-btn variant="text" size="small" class="text-none" to="/privacy-policy">Privacy</v-btn>
          <template v-if="isLoggedIn">
            <v-btn variant="text" size="small" class="text-none" to="/discover">Recipes</v-btn>
            <v-btn variant="text" size="small" class="text-none" to="/settings">Settings</v-btn>
            <FeedbackDialog>
              <template #activator="{ props }">
                <v-btn v-bind="props" variant="text" size="small" class="text-none">Feedback</v-btn>
              </template>
            </FeedbackDialog>
            <v-btn variant="text" size="small" class="text-none" @click="emit('logout')">Log out</v-btn>
          </template>
          <template v-else>
            <v-btn variant="text" size="small" class="text-none" to="/features">Features</v-btn>
            <v-btn variant="text" size="small" class="text-none" to="/pricing">Pricing</v-btn>
            <v-btn variant="text" size="small" class="text-none" to="/discover">Recipes</v-btn>
            <v-btn variant="text" size="small" class="text-none" to="/login">Sign In</v-btn>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useUserStore } from '@/stores/userStore'
import FeedbackDialog from '@/components/FeedbackDialog.vue'

const userStore = useUserStore()
const currentYear = new Date().getFullYear()
const isLoggedIn = computed(() => userStore.isLoggedIn)
const emit = defineEmits<{ logout: [] }>()
</script>

<style scoped>
.site-footer {
  min-height: 188px;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

@media (min-width: 960px) {
  .site-footer {
    min-height: 96px;
  }
}
</style>